<template>  
  <div class="container" v-if="allUnapprovedBookings" style="min-height: 700px;">
    <div class="row margin-bottom-10 margin-top-20 mybookings-header">
      <div class="col-12">
        <div class="card afas-gold">
          <div class="card-content">
            <h5 class="margin-top-10 margin-bottom-10 white-text">All Bookings Awaiting Approval</h5>
            <a class="waves-effect waves-light white teal-text btn-small btn-block back-button" @click="goBack">Go Back</a>
          </div>
        </div>
      </div>
    </div>
    <div class="progress" v-if="loading">
        <div class="indeterminate"></div>
    </div>
    <span>
      <div class="row calendar-card card margin-top-10">
          <div class="col-12 card-content">
                <div class="row">
                    <div class="col-12">
                        <table class="striped highlight responsive-table">
                            <thead>
                                <th>Date</th>
                                <th>Day</th>
                                <th>Location</th>
                                <th>Employee</th>
                                <th>Reason</th>
                                <th class="center">Actions</th>
                            </thead>
                            <tbody>
                                <tr class="scale-transition" v-for="booking in bookings" :key="booking.id">
                                    <td width="100px" :class="{'success': booking.success }">{{ booking.date }}</td>
                                    <td width="130px" :class="{'success': booking.success }">{{ booking.day }}</td>
                                    <td width="130px" :class="{'success': booking.success }">{{ booking.location }}</td>
                                    <td width="200px" :class="{'success': booking.success }">{{ booking.employee }}</td>
                                    <td style="font-size: 0.7em">{{ booking.reason }}</td>
                                    <td class="center delete-icon" width="140px" style="font-size: 0.7em">
                                        <button v-tooltip="'Instantly Approve'" class="btn btn-small green" style="padding: 0 10px;" @click="approveTheBooking(booking)"><i class="material-icons">alarm_on</i></button>
                                        <router-link :to="{ path: '/approve/' + booking.id + '/1234/1'}" v-tooltip="'Approve'"><button class="btn btn-small" style="padding: 0 10px;"><i class="material-icons">verified</i></button></router-link>
                                        <router-link :to="{ path: '/approve/' + booking.id + '/1234/2'}" v-tooltip="'Deny'"><button class="btn btn-small red" style="padding: 0 10px;"><i class="material-icons">delete</i></button></router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </span>
    <span v-if="approved">
        <div style="width: 400px; position: absolute; top: 40px; right: 10px;" class="green card">
            <div style="padding: 15px;">
                <span class="material-icons" style="font-size: 16px">
                    check_circle
                </span> 
                <span style="margin-left: 15px; font-size: 18px"> Boeking Goedgekeurd!
                </span>
            </div>   
        </div>
    </span>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment'
import firebase from "firebase";
export default {
name: 'AllUnapproved',
data () {
    return {
        bookings: null,
        loading: true,
        user: null,
        processing: false,
        approved: false,
    }
  },
  computed: {
      ...mapGetters(['allUnapprovedBookings']),
  },
  methods: {
    ...mapActions(['setAllUnapprovedBookings', 'deleteBooking', 'approveBooking']),
    goBack() {
        this.$router.go(-1);
    },
    createDatesFromTimestamps(){
        var location_id = 1;
        this.bookings = this.allUnapprovedBookings;
        for(var i = 0; i < this.bookings.length; i++){
            this.bookings[i].date = moment(this.bookings[i].timestamp).format("Do MMM")
            this.bookings[i].day = moment(this.bookings[i].timestamp).format("dddd")
        }
        this.bookings.sort((a, b) => a.timestamp - b.timestamp );
        this.loading = false;
    },
    async approveTheBooking(booking) {
        if(!this.processing){
            this.approved       = false;
            this.processing     = true;
            var info ={
                bookingid: booking.id,
                officeid: booking.officeid,
                status:  1,
            }
            if(info.status == 1){
                await this.approveBooking(info);
                await this.setAllUnapprovedBookings();
                this.createDatesFromTimestamps();
                this.processing = false
                this.approved = true;
                setTimeout(() => this.approved = false, 2000);
            } else {

            }
        } else {
            console.log("De bewerking is nog bezig.")
        }
    },
  },
  async mounted() {
        var firebaseUser = await firebase.auth().currentUser;
        this.user = firebaseUser;
        await this.setAllUnapprovedBookings();
        this.createDatesFromTimestamps();
  }
}
</script>

<style scoped>

    .calendar-card {
        position: relative;
    }

    .mybookings-header .back-button {
        position: absolute;
        top: 15px;
        right: 15px;;
    }

    .delete-icon {
        cursor: pointer;
    }

    .delete-icon:hover {
        color: grey;
    }

    .just-deleted {
        text-decoration: line-through;
        background-color: rgba(255, 0, 0, 0.3);
    }

</style>


// WEBPACK FOOTER //
// src/components/bookings/allAwaitingApproval.vue